export const updateComponent = (id, data) => ({
  type: 'UPDATE_COMPONENT',
  id, data,
})
